import { Trans } from '@lingui/react/macro';
import { CloudOff, RotateCw } from 'lucide-react';

import { RuntimeConfigError } from '@/shared/config';
import { Button } from '@/shared/ui/button';

import { AuthLayout } from './auth-layout';
import { AuthHeading } from './auth-ui';

/** Tela de falha do boot (config do domínio ausente ou inválida). Sem casca, sem API, sem marca. */
export function BootErrorScreen({ error }: { error: unknown }) {
  const source = error instanceof RuntimeConfigError ? error.source : undefined;
  return (
    <AuthLayout>
      <div className="flex flex-col gap-7">
        <AuthHeading icon={CloudOff} title={<Trans>Não foi possível carregar o UYZY</Trans>}>
          <Trans>A configuração deste endereço não foi encontrada. Tente de novo em instantes ou fale com o suporte.</Trans>
        </AuthHeading>
        {source ? (
          <p className="rounded-xl border border-border bg-card px-3.5 py-3 font-mono text-xs break-all text-muted-foreground">{source}</p>
        ) : null}
        <Button block size="lg" className="md:h-11" onClick={() => globalThis.location.reload()}>
          <RotateCw aria-hidden className="size-4" />
          <Trans>Tentar de novo</Trans>
        </Button>
      </div>
    </AuthLayout>
  );
}
